import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsForSection() {
  const isFor = ['Mujeres que sienten una descarga eléctrica o ardor que baja por la pierna.', 'Quienes sienten que la espalda baja se "bloquea" al levantarse de una silla.', 'Personas que han probado masajes y pastillas sin resultados permanentes.', 'Madres y profesionales que no pueden permitirse días de reposo en cama.'];
  const isNotFor = ['Personas que buscan una "pastilla mágica" sin dedicar 8 minutos a moverse.', 'Casos médicos que requieren cirugía de emergencia de columna.', 'Quienes no estén dispuestos a seguir instrucciones posturales básicas.'];
  return <section className="py-16 md:py-24 bg-white" data-id="element-193">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-194">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-195">
          {/* Es para ti */}
          <FadeIn direction="right" data-id="element-196">
            <div className="bg-teal-50 rounded-2xl p-8 h-full border border-teal-100" data-id="element-197">
              <h3 className="text-2xl font-serif font-bold text-teal-900 mb-6 flex items-center gap-3" data-id="element-198">
                <div className="bg-teal-200 p-2 rounded-full" data-id="element-199">
                  <Check className="w-6 h-6 text-teal-700" data-id="element-200" />
                </div>
                ESTO ES PARA TI SI:
              </h3>
              <ul className="space-y-5" data-id="element-201">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-202">
                    <Check className="w-5 h-5 text-teal-600 flex-shrink-0 mt-1" data-id="element-203" />
                    <span className="text-gray-700 leading-relaxed" data-id="element-204">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* No es para ti */}
          <FadeIn direction="left" delay={0.2} data-id="element-205">
            <div className="bg-coral-50 rounded-2xl p-8 h-full border border-coral-100" data-id="element-206">
              <h3 className="text-2xl font-serif font-bold text-coral-900 mb-6 flex items-center gap-3" data-id="element-207">
                <div className="bg-coral-200 p-2 rounded-full" data-id="element-208">
                  <X className="w-6 h-6 text-coral-700" data-id="element-209" />
                </div>
                ESTO NO ES PARA TI SI:
              </h3>
              <ul className="space-y-5" data-id="element-210">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-211">
                    <X className="w-5 h-5 text-coral-600 flex-shrink-0 mt-1" data-id="element-212" />
                    <span className="text-gray-700 leading-relaxed" data-id="element-213">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}